import type { VariableDefinitionContext } from '../script/variable-definition.js'
import type { BoInput } from './bo-input.js'
import type { ScreenOutput } from './screen-output.js'
import type { BoReference } from './bo-reference.js'
import { RestrictableItem } from './restrictions/restrictable-item.js'

export interface BoSpecificDetailsQuery {
	inputContexts?: VariableDefinitionContext[]
}

export interface BoSpecificDetails {
	subTypes?: Record<string, string>
	inputs?: BoInput[]
	outputs?: ScreenOutput[]
	placeholders?: string[]
	allPropertyNames?: string[]
	restrictableItems?: RestrictableItem[]
}

export function getBoSpecificDetailsCacheKey(
	boRef: BoReference,
	query: BoSpecificDetailsQuery,
) {
	return `${boRef?.getQualifiedTypeAndName()}_${query?.inputContexts?.join('|')}`
}
